<template>
    <div>
        <!--Stats cards-->
        <div class="row">
            <div class="col-md-6 col-xl-3" v-for="stats in statsCards" :key="stats.title">
                <stats-card>

                    <div class="icon-big text-center" :class="`icon-${stats.type}`" slot="header">
                        <div class="text-center" v-if="loader1">
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden"></span>
                            </div>
                        </div>
                        <i :class="stats.icon"></i>
                    </div>
                    <div class="numbers" slot="content">
                        <p>{{ stats.title }}</p>
                        {{ stats.value }}

                    </div>
                    <!-- <div class="stats" slot="footer">
                    <i :class="stats.footerIcon"></i> {{ stats.footerText }}
                </div> -->
                </stats-card>
            </div>
        </div>

        <!-- Njoftimet -->
        <div class="row">
            <div class="col-md-6 col-12">
                <card>
                    <h5 class="text-center text-muted">Lajm&euml;rimet e fundit</h5>

                    <div class="text-center" v-if="loader2">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </div>

                    <div class="alert alert-info alert-with-icon shadow-sm bg-light rounded text-dark"
                        data-notify="container" v-for="item in njoftimet" :key="item.id" id="show_notification">
                        <span class="float-right">{{ item.data }}</span>
                        <span data-notify="icon" class="ti-announcement"></span>
                        <span data-notify="message"> <a :href="item.porosia" target="_blank">{{ item.titulli }}</a></span>
                    </div>
                </card>
            </div>
            <!--Charts-->
            <div class="col-md-6 col-12">
                <chart-card title="" sub-title="Notat e paraqitura gjatë studimeve " :chart-data="activityChart.data"
                    :chart-options="activityChart.options">

                    <span slot="footer">
                        <i class="ti-check"></i> Notat gjat&#235; viteve
                    </span>
                    <!-- <div slot="legend">
                    <div class="text-center" v-if="loader3">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                        </div>
                    </div>
                    <i class="fa fa-circle text-warning"></i> Viti 1
                    <i class="fa fa-circle text-danger"></i> Viti 2
                    <i class="fa fa-circle text-muted"></i> Viti 3
                    <i class="fa fa-circle text-success"></i> Viti 4
                </div> -->
                </chart-card>
            </div>

        </div>


    </div>
</template>

<script>
import { StatsCard, ChartCard } from "@/components/index";
import moment from 'moment'
import { APISettings } from '../api/config.js'

export default {
    components: {
        StatsCard,
        ChartCard,
    },

    data()
    {
        return {
            njoftimet: [],
            show_info: [],
            mesatarja: "",
            pagesat: [],
            viti1: [],
            viti2: [],
            viti3: [],
            viti4: [],
            loader1: false,
            loader2: false,
            loader3: false,

            statsCards: [{
                type: "danger",
                icon: "ti-wallet",
                title: "Për pagesë:",
                value: "",
                footerText: "Last day",
                footerIcon: "ti-calendar",
            },
            {
                type: "danger",
                icon: "ti-pulse",
                title: "Provimet e Kaluara",
                value: "",
                footerText: "In the last hour",
                footerIcon: "ti-timer",
            },
            {
                type: "danger",
                icon: "ti-paint-bucket",
                title: "ECTS:",
                value: "",
                footerText: "Updated now",
                footerIcon: "ti-reload",
            },
            {
                type: "danger",
                icon: "ti-bar-chart",
                title: "Nota mesatare:",
                mesatarja: "",
                footerText: "Updated now",
                footerIcon: "ti-reload",
            },
            ],
            activityChart: {
                data: {
                    labels: [
                        "N1",
                        "N2",
                        "N3",
                        "N4",
                        "N5",
                        "N6",
                        "N7",
                        "N8",
                        "N9",
                        "N10",
                    ],
                    series: [
                        [],
                        [],
                        [],
                        []
                    ],
                },
                options: {
                    seriesBarDistance: 1,
                    axisX: {
                        showGrid: true,
                    },
                    height: "245px",

                },
            },
        };
    },

    methods: {
        // NJOFTIMET

        getData1()
        {
            this.loader2 = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Njoftimet/getNjoftimetStudent/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {

                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {

                                res.forEach((obj) =>
                                {
                                    const formattedDate = moment(obj.data).format('DD/MM/YYYY');
                                    obj.data = formattedDate;
                                    this.njoftimet = res;
                                    if (this.njoftimet.length < 7)
                                    {
                                        this.njoftimet = res;
                                    } else
                                    {
                                        this.njoftimet.length = 7;
                                    }



                                    if (obj.titulli === undefined)
                                    {
                                        obj.titulli = "Kliko ketu"
                                    }
                                });
                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                            this.loader2 = false;
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

        // Nota Mesatare
        getData2()
        {
            this.loader1 = true;
            var get_token = this.$cookies.get("accesstoken");

            fetch(APISettings.baseURL + `Notat/getNotatenMesatare/`, {

                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {
                        signinResponse.json().then((res) =>
                        {
                            this.statsCards[1].value = res[0].countNota;
                            this.statsCards[2].value = res[0].kredite;
                            if (signinResponse.status === 200)
                            {
                                this.laoder1 = false;
                                res.forEach(obj =>
                                {
                                    this.statsCards[3].value = obj.nota_Mesatare;
                                });

                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }

                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

        // Totali pageses:
        getTotali()
        {
            this.loader1 = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Pagesat/getTotalPagesat/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {
                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {
                                res.forEach((obj) =>
                                {
                                    this.loader1 = false;
                                    this.statsCards[0].value = obj.per_pagese.toFixed(2);
                                });

                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

        // Notat
        getNotat()
        {

            this.loader3 = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Notat/getNotatVite`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + get_token
                },
            })
                .then(
                    (signinResponse) =>
                    {
                        signinResponse.json().then((res) =>
                        {
                            if (signinResponse.status === 200)
                            {
                                this.viti1.push(res[0]);
                                var obj = this.viti1;
                                var result = Object.keys(obj).map((key) => [Number(key), obj[key]]);
                                this.viti1 = result;

                                // Mbushja me nota e grafit
                                this.activityChart.data.series[0] = this.viti1[0][1].notatar;
                                this.activityChart.data.series[1] = this.viti1[0][1].notatar2;
                                this.activityChart.data.series[2] = this.viti1[0][1].notatar3;
                                this.activityChart.data.series[3] = this.viti1[0][1].notatar4;

                            } else if (signinResponse.status === 400)
                            {
                                console.log("ERROR DATA1");
                            }
                            this.loader3 = false;
                        })
                    }).catch(error =>
                    {
                        console.log("ERROR DATA2");
                    })
        },

    },

    beforeMount()
    {
        this.getData1();
        this.getData2();
        this.getTotali();
        this.getNotat();
    },
};
</script>

<style></style>
